import AccountCircleIcon           from '@/assets/icons/AccountCircleIcon';
import CalendarIcon                from '@/assets/icons/CalendarIcon';
import ContactsIcon                from '@/assets/icons/ContactsIcon';
import HeartIcon                   from '@/assets/icons/HeartIcon';
import HomeIcon                    from '@/assets/icons/HomeIcon';
import NewsletterIcon              from '@/assets/icons/NewsletterIcon';
import SecurityIcon                from '@/assets/icons/SecurityIcon';
import SettingsIcon                from '@/assets/icons/SettingsIcon';
import TicketIcon                  from '@/assets/icons/TicketIcon';
import TransferIcon                from '@/assets/icons/TransferIcon';
import WorkIcon                    from '@/assets/icons/WorkIcon';
import { useTranslation }          from 'react-i18next';
import useTranslations             from '@/hooks/useTranslations';
import EntityIcon                  from '@/assets/icons/EntityIcon';
import StandIcon                   from '@/assets/icons/StandIcon';

type MenuItem = {
	key: string,
	label: string,
	to: string,
	icon: JSX.Element,
	subItems: MenuItem[],
};

type PageKey = {
	label: string,
	type: 'private' | 'public'
}

export type MenuItems = MenuItem[];

const useMenu = () => {
	const { i18n } = useTranslation();
	const { SUPPORTED_LANGUAGES, getNavigationTranslation } = useTranslations();

	const PAGE_KEYS: PageKey[] = [
		{ label: 'login', type: 'public' },
		{ label: 'registration', type: 'public' },
		{ label: 'resetPassword', type: 'public' },
		{ label: 'confirmationEmail', type: 'public' },
		{ label: 'confirmationRegistration', type: 'public' },
		{ label: 'confirmationResetPassword', type: 'public' },
		{ label: 'home', type: 'private' },
		{ label: 'personalInformation', type: 'private' },
		{ label: 'settings', type: 'private' },
		{ label: 'security', type: 'private' },
		{ label: 'editStand', type: 'private' },
		{ label: 'stands', type: 'private' },
		{ label: 'contacts', type: 'private' },
		{ label: 'newsletters', type: 'private' },
		{ label: 'ticket', type: 'private' },
		{ label: 'tickets', type: 'private' },
		{ label: 'transfers', type: 'private' },
		{ label: 'daisuki', type: 'private' },
		{ label: 'agenda', type: 'private' },
		{ label: 'candidacies', type: 'private' },
	];
	
	const MENU_ITEMS: MenuItems = [
		{
			key: 'home',
			label: getNavigationTranslation('home', 'label'), 
			to: getNavigationTranslation('home', 'path'), 
			icon: <HomeIcon fontSize="20px" />,
			subItems: [],
		},
		{
			key: 'personalInformation',
			label: getNavigationTranslation('personalInformation', 'label'), 
			to: getNavigationTranslation('personalInformation', 'path'),
			icon: <AccountCircleIcon fontSize="20px" />,
			subItems: [],
		},
		{
			key: 'settings',
			label: getNavigationTranslation('settings', 'label'), 
			to: getNavigationTranslation('settings', 'path'), 
			icon: <SettingsIcon fontSize="20px" />,
			subItems: [],
		},
		{
			key: 'security',
			label: getNavigationTranslation('security', 'label'), 
			to: getNavigationTranslation('security', 'path'), 
			icon: <SecurityIcon fontSize="20px" />,
			subItems: [],
		},
		{
			key: 'entities',
			label: getNavigationTranslation('entities', 'label'),
			to: getNavigationTranslation('entities', 'path'),
			icon: <EntityIcon fontSize="20px" />,
			subItems: [],
		},
		{
			key: 'stands',
			label: getNavigationTranslation('stands', 'label'),
			to: getNavigationTranslation('stands', 'path'),
			icon: <StandIcon fontSize="20px" />,
			subItems: [],
		},
		{
			key: 'contacts',
			label: getNavigationTranslation('contacts', 'label'), 
			to: getNavigationTranslation('contacts', 'path'), 
			icon: <ContactsIcon fontSize="20px" />,
			subItems: [],
		},
		{
			key: 'newsletters',
			label: getNavigationTranslation('newsletters', 'label'), 
			to: getNavigationTranslation('newsletters', 'path'),  
			icon: <NewsletterIcon fontSize="20px" />,
			subItems: [],
		},
		{
			key: 'tickets',
			label: getNavigationTranslation('tickets', 'label'), 
			to: getNavigationTranslation('tickets', 'path'),
			icon: <TicketIcon fontSize="20px" />,
			subItems: [],
		},
		{
			key: 'transfers',
			label: getNavigationTranslation('transfers', 'label'), 
			to: getNavigationTranslation('transfers', 'path'), 
			icon: <TransferIcon fontSize="20px" />,
			subItems: [],
		},
		{
			key: 'daisuki',
			label: getNavigationTranslation('daisuki', 'label'), 
			to: getNavigationTranslation('daisuki', 'path'), 
			icon: <HeartIcon fontSize="20px" />,
			subItems: [],
		},
		{
			key: 'agenda',
			label: getNavigationTranslation('agenda', 'label'), 
			to: getNavigationTranslation('agenda', 'path'), 
			icon: <CalendarIcon fontSize="20px" />,
			subItems: [],
		},
		{
			key: 'candidacies',
			label: getNavigationTranslation('candidacies', 'label'), 
			to: getNavigationTranslation('candidacies', 'path'), 
			icon: <WorkIcon fontSize="20px" />,
			subItems: [],
		},
	];

	const getCurrentPageKey: () => undefined | PageKey = () => {
		let currentPageKey = undefined;

		SUPPORTED_LANGUAGES.forEach(language => {

			const dataByLanguage = i18n.getDataByLanguage(language);
			const locationPathname = location.pathname.split('/')[2];
	
			for (const [key, value] of Object.entries(dataByLanguage?.translation.pages as unknown as object)) {
				if (value.path === `/${locationPathname}`) {
					const newKey = PAGE_KEYS.find(pageKey => pageKey.label === key)
					currentPageKey = newKey;
				}
			}
		})
		
		return currentPageKey;
	}

	return {
		MENU_ITEMS,
		PAGE_KEYS,
		getCurrentPageKey,
	}
}

export default useMenu;